import {forwardRef} from 'react';
import cN from 'classnames';


const LocationManagerList = forwardRef(({children, onDelete, className, ...props}, ref) => (
    <ul
        className={cN('location-manager-list', className)}
        ref={ref}
        {...props}
    >
        {children}
    </ul>
));

export default LocationManagerList;
